import { render } from "./Reminder.vue?vue&type=template&id=bd2019be"
import script from "./Reminder.vue?vue&type=script&lang=js"
export * from "./Reminder.vue?vue&type=script&lang=js"
script.render = render

export default script